<template >
  <div>
    <div class="col-lg-12">
      <div class="card shadow mb-4">
          <div class="card-header row m-0">
            <div class='col'>
              <h4 class="text-center">{{languages[lang].info}}</h4>
            </div>
            <div class="col col-auto" v-if="edit && edit==true">
              <div class="btn btn-info btn-sm">
                <router-link :to="{ name: 'LessonEdit', params: {lessonId: lesson.id}}" class="text-white">засах</router-link>
              </div>
              <div class="btn btn-info btn-sm ml-2">
                <router-link :to="{ name: 'LessonBook', params: {parentPath: 'lessons/'+lesson.id}}" class="text-white">ном</router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p style="margin-bottom: 0rem;" class="h4 text-primary">{{lesson.name}}</p>
            <p style="margin-bottom: 0rem;">
              Багш:
              <span v-if="lesson.teachers">
                  {{lesson.teachers[0].firstName}}
              </span>

              <span v-if="lesson.teachers">
                  / {{lesson.teachers[0].lastName}}
              </span>
              <span style="font-weight:bold">{{lesson.profession}}</span>
            </p>
            <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
              <vue-qrcode v-if="lesson" :value="lesson.lectureCode.toString()" />
            <p style="margin-bottom: 0rem;" v-if="lesson.semester && lesson.semester.title">Улирал: <span style="font-weight:bold">{{lesson.semester.title}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p>
            <span v-if="lesson.isBlock!=true">
              <p class="mb-0" v-if="lesson.school">Сургууль: {{lesson.school.id}}</p>
              <p class="mb-0" v-if="lesson.department">Xөтөлбөрийн баг(Тэнхим): {{lesson.department.id}}</p>
            </span>
            <span v-else>
              Блок хичээл
            </span>
            <hr/>
            <p>{{lesson.description}}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-12" v-if="showDetail && showDetail==true">
        <div class="card mb-4">   
          <div class="card-header row m-0">
            <div class='col'>
              <h4 class="text-center">{{languages[lang].extrainfo}}</h4>
            </div>
            <div class="col col-auto">
              <h5 v-if="lesson.published==true" style="cursor:pointer" @click="setPublished(false,lesson)"><span class="badge badge-success">Нээлттэй</span></h5>
              <h5 v-else @click="setPublished(true,lesson)" style="cursor:pointer"><span class="badge badge-danger">Хаалттай</span></h5>
            </div>
          </div>  
          <div class="card-body"> 
            <div class="row  text-center text-lg-left mt-5" v-if="lesson.images!=null && lesson.images.length>0">
              <div class="col-lg-3 col-md-4 col-6" v-for="(file) in lesson.images" v-bind:key="file.fileUrl">
                  <a href="#" class="d-block mb-4 h-100">
                  <img class="img-fluid" :src="file.fileUrl" />
                  </a>
              </div>
            </div>
            <div class="my-4"  v-if="lesson.results!=null && lesson.results.length>0">
              <h5>{{languages[lang].lessongoals}}</h5>
              <ul >
                <li v-for="(include) in lesson.results" v-bind:key="include">{{include}}</li>
              </ul>
            </div>
            <div class="my-4" v-if="lesson.requirements!=null && lesson.requirements.length>0">
              <h5>{{languages[lang].lessonreqs}}</h5>
              <ul >
                <li v-for="(include) in lesson.requirements" v-bind:key="include">{{include}}</li>
              </ul>
            </div>
            <div class="my-4" v-if="lesson.whatlearned!=null && lesson.whatlearned.length>0">
              <h5>{{languages[lang].lessonwhat}}</h5>
              <ul >
                <li v-for="(include) in lesson.whatlearned" v-bind:key="include">{{include}}</li>
              </ul>
            </div>
            

            <div class="my-4"  v-if="lesson.handlaga!=null && lesson.handlaga.length>0">
              <h5>{{languages[lang].lessonskills}}</h5>
              <ul >
                <li v-for="(include) in lesson.handlaga" v-bind:key="include">{{include}}</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
  </div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase';
import VueQrcode from 'vue-qrcode';
import lang from '../lang.js';


export default {
    name: "LessonInfo",

    data() {
        return {

        };
    },
    mixins:[lang],
    components: {
      VueQrcode,
    },
    created(){
      if(this.lesson && this.lesson.semester){
        
        this.lesson.semester.get().then(doc=>{

          if(doc.exists){
            this.lesson.semester=null;
            this.lesson.semester=doc.data();
          }
        });
      }
    },
    methods: {
      setPublished(value, lesson){
        if(this.edit && this.edit==true){
          this.setProperty("published", fb.db.doc("lessons/"+this.lesson.id), value);
 
        }
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    },

    props: {
      lesson:{
        required:true
      },
      edit:{
        required:false
      },
      showDetail:{
        required:false
      }
    },
    computed: {
        ...mapState(['lang'])
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

